export default {

    //预置主题色
    none: "transparent",
    main: "#051c24",
    sub: "#b4967a",
    light: "#fff",
    lgray: "#eee",
    mgray: "#a7a7a7",
    dgray: "#373737",
    dark: "#111",
    purple: "#3f178e",
    blue: "#223dcd",
    dblue: "#122b45",
    green: "#02b9a1",
    yellow: "#fdba00",
    dyellow: "#403422",
    red: "#ec4334",
    neutral: "rgba(134,134,134,.17)",

}


// WEBPACK FOOTER //
// ./src/components/BTXUI/core/styles/theme.js